import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=672c84d1&scoped=true&lang=html&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c84d1",
  null
  
)

export default component.exports